<template>
  <section>
    <div class="row">
      <div class="col-6">
        <input type="search"
               class="form-control form-control-sm"
               placeholder="ค้นหา..."
               v-model="keyword"
               @keyup.enter="searchConversation()">
      </div>
      <div class="col-6">
        <div class="d-flex justify-content-start align-items-center">
          <div class="pr-2" :style="selectedTags ? `color: ${selectedTags.color}` : ''">
            <i class="fas fa-tag"></i>
              <div class="form-group" style="font-size: 85%;">
                <div class="custom-control custom-checkbox mb-0">
                    <input type="checkbox" class="custom-control-input cursor-pointer"
                          :true-value="1" :false-value="0" v-model="filterByAndOr"
                          @change="searchConversation()"
                          id="filter-by-and-or"
                          name="filterByAndOr">
                    <label class="custom-control-label cursor-pointer filter-label"
                          for="filter-by-and-or">
                        {{ filterByAndOr === 1 ? 'และ': 'หรือ' }}
                        <p style="margin: 0;" class="filter-tooltip" :data-tooltip="filterByAndOr === 1 ? 'ใช้การค้นหาแบบ และ (AND) หมายถึงต้องมี tag ตรงตามที่เลือกทั้งหมดจึงจะแสดง': 'ใช้การค้นหาแบบ หรือ (OR) หมายถึงมี tag ตรงตามที่เลือกอย่างน้อย 1 ตัวก็จะแสดง'">
                            <i class="fas fa-info-circle"></i>
                        </p>
                    </label>
                </div>
            </div>
          </div>
          <div class="flex-grow-1">
            <v-select id="tags"
                      placeholder="เลือกแท็ก"
                      name="tags"
                      label="name"
                      multiple
                      :options="tags"
                      :value="selectedTags"
                      @input="onChange"
                      v-if="tags">
              <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  v-bind="attributes"
                  v-on="events"/>
              </template>
              <template v-slot:option="option">
                <span :style="`color: ${option.color}`">{{ option.name }}</span>
              </template>
            </v-select>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="admins">
      <div class="col-6">
        <multiselect
          v-model="admin"
          id="professional"
          label="name"
          track-by="name"
          placeholder="แอดมิน"
          open-direction="bottom"
          :options="admins"
          :searchable="true"
          ref="selectedItems"
          @input="onChangeAdmin">
          <template slot="beforeList">
            <div class="row">
              <div class="col p-2 row-message-template">
                <button class="btn btn-link btn-block text-reset text-decoration-none text-small" @click="selectAll">
                  เลือกทั้งหมด
                </button>
              </div>
            </div>
          </template>
          <template slot="option" slot-scope="props">
            <div class="option__desc d-inline-block">
              <img :src="props.option.profile_picture" width="40" class="rounded-circle img-circle-md">
              <span class="option__title">&nbsp;&nbsp;{{ props.option.name }}</span>
            </div>
          </template>
          <template slot="singleLabel" slot-scope="{ option }">
            <img :src="option.profile_picture" width="40" class="rounded-circle img-circle-md mr-2">{{ option.name }}
          </template>
        </multiselect>
        <div class="recruitment-date-filter mt-2" v-if="showRecruitmentCreatedDateFilter">
          <span class="recruitment-date-label">
            <i class="far fa-calendar-alt mr-1"></i>สนทนาครั้งแรก
          </span>
          <datepicker :format="'dd/MM/yyyy'"
                      :inputClass="'form-control form-control-sm recruitment-date-input'"
                      :placeholder="'dd/mm/yyyy'"
                      v-model="conversationCreatedDate"
                      @input="searchConversation" />
          <button v-if="conversationCreatedDate"
                  type="button"
                  class="btn btn-outline-secondary btn-sm recruitment-date-clear"
                  @click="clearCreatedDate()">
            ล้าง
          </button>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group" style="font-size: 85%;">
          <div class="custom-control custom-checkbox mb-0">
            <input type="checkbox" class="custom-control-input cursor-pointer"
                   :true-value="1" :false-value="0" v-model="unread" @change="searchConversation()"
                   id="unread-check" name="unread-check">
            <label class="custom-control-label cursor-pointer" for="unread-check">ข้อความที่ยังไม่ได้อ่าน</label>
          </div>
          <div class="custom-control custom-checkbox mb-0">
            <input type="checkbox" class="custom-control-input cursor-pointer"
                   :true-value="1" :false-value="0" v-model="isNotResponse" @change="searchConversation()"
                   id="response-check" name="response-check">
            <label class="custom-control-label cursor-pointer" for="response-check">ข้อความที่ยังไม่ได้ตอบ</label>
          </div>
          <div class="custom-control custom-checkbox mb-0"
               v-if="(searchConversationParams && searchConversationParams.customer_type === 'customer' && searchConversationParams.menu !== 'reminder')">
            <input type="checkbox" class="custom-control-input cursor-pointer"
                   :true-value="1" :false-value="0" v-model="isReminder" @change="searchConversation()"
                   id="is-reminder-check" name="is-reminder-check">
            <label class="custom-control-label cursor-pointer" for="is-reminder-check">ข้อความที่มีการแจ้งเตือน</label>
          </div>
          <div class="custom-control custom-checkbox mb-0"
               v-if="(searchConversationParams && searchConversationParams.customer_type === 'customer')">
            <input type="checkbox" class="custom-control-input cursor-pointer"
                   :true-value="1" :false-value="0" v-model="isEmergency" @change="searchConversation()"
                   id="is-emergency-check" name="is-emergency-check">
            <label class="custom-control-label cursor-pointer" for="is-emergency-check">ด่วน!</label>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="customerType === 'beneat_professional'">
      <div class="col-7">
        <div class="form-group">
          <v-select label="full_name"
                    name="name"
                    v-model="selectedProfessional"
                    :filterable="false"
                    :options="professionals"
                    placeholder="ระบุชื่อ หรือ ID คุณแม่บ้าน"
                    @search="onSearchProfessional"
                    @input="searchConversation">
            <template #search="{attributes, events}">
              <input
                class="vs__search"
                v-bind="attributes"
                v-on="events"
              />
            </template>
            <template slot="no-options">
              กรุณาระบุรหัสหรือชื่อคุณแม่บ้าน
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                <img
                  :src="option.picture_url || require('@/assets/no_photos.png')"
                  width="35"/>&nbsp;
                {{ 'ID:' + option.id + ' ' + option.full_name }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center" style="font-size: 11px;">
                <img
                  :src="option.picture_url || require('@/assets/no_photos.png')"
                  width="35"/>&nbsp;
                {{ 'ID:' + option.id + ' ' + option.full_name }}
              </div>
            </template>
          </v-select>
        </div>
      </div>
      <div class="col-5">
        <div class="form-group">
          <select class="form-control" v-model="selectedProvinceId" @change="searchConversation()">
            <option :value="null">ทุกจังหวัด</option>
            <option v-for="(item, index) in provinces" :value="item.id" :key="index">
              {{ item.name_th }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <select class="form-control" v-model="professionalGroup" @change="searchConversation()">
            <option :value="null">ทุกกลุ่ม</option>
            <option :value="0">กลุ่ม 0</option>
            <option :value="1">กลุ่ม A</option>
            <option :value="2">กลุ่ม B</option>
            <option :value="3">กลุ่ม C</option>
            <option :value="4">กลุ่ม H</option>
            <option :value="-1">ยกเว้นกลุ่ม 0</option>
          </select>
        </div>
      </div>
    </div>

    <div class="" v-if="admins && (customerType === 'beneat_professional' || customerType === 'customer')">
      <div class="d-flex">
        <div class="flex-grow-1">
          <b-button class="btn-sm" block v-b-toggle:topic-collapse variant="outline-info"
                    v-if="((customerType === 'beneat_professional' && !disableMenuTypes.includes(menuType) ||
                    (customerType === 'customer' && !disableMenuTypes.includes(menuType))))">
            กรองตามหัวข้อ <span class="when-open">&#8722;</span><span class="when-closed">&#43;</span>
          </b-button>
        </div>
        <div class="pl-2"
             v-if="conditionClearChatTopic">
          <button class="btn btn-danger btn-sm"
                  @click="customerType === 'customer' ? onChange(null) : clearSelectedChatTopic()">Clear หัวข้อ
          </button>
        </div>
      </div>
      <b-collapse id="topic-collapse" class="mt-2" v-model="visibleCollapse">
        <b-card-body class="card">
          <section v-if="customerType === 'beneat_professional'">
            <div v-for="(parentChatTopic, key) in parentChatTopics" :key="key">
              <div class="row py-1 chat-topic-row"
                   :class="{ 'bg-info text-white' : (selectedChatTopic && selectedChatTopic.id === parentChatTopic.id) }"
                   @click="searchConversationByChatTopicIds(parentChatTopic)">
                <div class="col-8">{{ parentChatTopic.name }}</div>
                <div class="col-4 text-right">
                  {{ parentChatTopic.conversation_qty }}
                </div>
              </div>
              <div class="dropdown-divider"></div>
            </div>
          </section>

          <section v-else-if="customerType === 'customer' && systemTags">
            <div class="row py-2 chat-topic-row" @click="onChange({id: 0, system: 1, tag_count: unTaggedConversationQty})"
                 :class="hasSelectTagId(0) ? 'bg-info text-white' : ''"
            >
              <div class="col-8 text-small">ไม่ได้ติดหัวข้อสนทนา</div>
              <div class="col-4 text-right">
                <span v-if="unTaggedConversationQty">{{ unTaggedConversationQty }}</span>
                <span v-else>0</span>
              </div>
            </div>
            <hr class="my-2">
            <div v-for="(multiLevelTag, index) in multiLevelTags" :key="index">
              <div class="row py-1"
                   :class="{'chat-topic-row' : multiLevelTag.can_select, 'bg-info text-white' : (hasSelectTagId(multiLevelTag.id)) }"
                   @click="(multiLevelTag.can_select) ? onChange(multiLevelTag) : null">
                <div :class="[multiLevelTag.can_select ? 'col-9' : 'col-12']">{{ multiLevelTag.name }}</div>
                <div class="col-3 text-right" v-if="multiLevelTag.can_select">{{ multiLevelTag.tag_count }}</div>
              </div>
              <div v-for="(childTag, key) in multiLevelTag.child_tags" :key="key">
                <div class="row py-2 chat-topic-row pl-4"
                     :class="{ 'bg-info text-white' : (hasSelectTagId(childTag.id)) }"
                     @click="onChange(childTag)">
                  <div class="col-8">{{ childTag.name }}</div>
                  <div class="col-4 text-right">
                    {{ childTag.tag_count }}
                  </div>
                </div>
              </div>
              <div class="dropdown-divider" v-if="(index + 1) !== multiLevelTag.length"></div>
            </div>
          </section>
        </b-card-body>
      </b-collapse>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'
import axios from 'axios'
import moment from 'moment'
import { nextTick } from 'vue'
import Datepicker from 'vuejs-datepicker'

export default {
  components: {
    Datepicker
  },
  props: {
    searchConversationParams: Object
  },
  data () {
    return {
      filterByAndOr: 0,
      keyword: null,
      admin: null,
      adminId: null,
      selectedTags: null,
      selectedChatTopic: null,
      unread: 0,
      isNotResponse: 0,
      isReminder: 0,
      isEmergency: 0,
      selectedProvinceId: null,
      selectedProfessional: null,
      professionals: [],
      provinces: [],
      visibleCollapse: false,
      unTaggedConversationQty: null,
      disableMenuTypes: ['resolved', 'line', 'facebook'],
      professionalGroup: null,
      selectedTagIds: [],
      conversationCreatedDate: null
    }
  },
  computed: {
    ...mapState('tag', ['tags', 'systemTags', 'multiLevelTags']),
    ...mapState('admin', ['admins', 'departmentTagIds']),
    ...mapState('conversation', ['selectedAdmin', 'customerType']),
    ...mapState('tag', ['countTaggedConversation']),
    ...mapState('chatTopic', ['chatTopics', 'parentChatTopics']),
    ...mapState('menu', { menuCount: 'menuCount', menuType: 'type' }),

    conditionClearChatTopic () {
      /* ของเดิม v-if="(selectedTag && selectedTag.system && !disableMenuTypes.includes(menuType)) ||
      (customerType === 'beneat_professional' && !disableMenuTypes.includes(menuType) && selectedChatTopic)" */
      if (this.selectedTags && this.selectedTags.length > 0) {
        const hasTagSystem = this.selectedTags.find(item => item.system)
        if ((hasTagSystem && !this.disableMenuTypes.includes(this.menuType)) || (this.customerType === 'beneat_professional' && !this.disableMenuTypes.includes(this.menuType) && this.selectedChatTopic)) {
          return true
        }
      }
      return false
    },
    showRecruitmentCreatedDateFilter () {
      return this.searchConversationParams &&
        ['recruitment_customer', 'recruitment_professional', 'recruitment_professional_secondary'].includes(this.searchConversationParams.customer_type)
    }
  },
  watch: {
    countTaggedConversation () {
      this.updateUnTaggedConversation()
    },
    menuCount () {
      this.updateUnTaggedConversation()
    },
    menuType () {
      // Init selected tag ids based on admin department
      if (this.menuType === 'active' && this.customerType === 'customer') {
        if (this.departmentTagIds) {
          this.selectedTagIds = this.departmentTagIds
          this.selectedTags = []
          for (let tagId of this.selectedTagIds) {
            this.selectedTags.push({ id: tagId, system: 1 })
          }
        }
        this.searchConversation()
        this.updateUnTaggedConversation()
      } else {
        this.onChange(null)
      }
      this.selectedChatTopic = null // Clear chat topic when change menu type
      if (this.menuType && this.disableMenuTypes.includes(this.menuType)) {
        this.visibleCollapse = false
      }
    },
    'searchConversationParams.menu': function (newVal, oldVal) {
      if (newVal !== 'active') {
        this.admin = null
      } else {
        this.admin = this.selectedAdmin
      }
    },
    keyword () {
      if (!this.keyword) {
        this.searchConversation()
      }
    },
    'searchConversationParams.customer_type' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedTags = null
        this.selectedTagIds = []
        this.conversationCreatedDate = null
      }
    },
    'searchConversationParams.conversation_created_date' () {
      this.syncConversationCreatedDate()
    }
  },
  methods: {
    ...mapActions('admin', ['fetchAdmins']),
    ...mapActions('tag', ['fetchTags', 'fetchSystemTags']),
    ...mapActions('chatTopic', ['fetchProfessionalChatTopics', 'fetchParentChatTopics']),
    hasSelectTagId (tagId) {
      return this.selectedTagIds.includes(tagId)
    },
    clearSelectedChatTopic () {
      this.selectedChatTopic = null
      this.searchConversation()
    },
    syncConversationCreatedDate () {
      const conversationCreatedDate = this.searchConversationParams
        ? this.searchConversationParams.conversation_created_date
        : null
      if (!conversationCreatedDate) {
        this.conversationCreatedDate = null
        return
      }

      const parsedDate = moment(conversationCreatedDate, 'YYYY-MM-DD', true)
      this.conversationCreatedDate = parsedDate.isValid() ? parsedDate.toDate() : null
    },
    clearCreatedDate () {
      this.conversationCreatedDate = null
      this.searchConversation()
    },
    getAllTags () {
      let formatData = Array.isArray(this.multiLevelTags) ? this.multiLevelTags : []
      let temp = []
      formatData.forEach(item => {
        if (item.child_tags) {
          temp.push(item.child_tags)
        }
      })
      temp = temp.flat()
      return formatData.concat(temp)
    },
    updateUnTaggedConversation () {
      this.unTaggedConversationQty = null
      if (this.menuCount && typeof this.countTaggedConversation === 'number') {
        // console.log('menu count', this.menuCount, '\ntags ', this.countTaggedConversation)
        switch (this.menuType) {
          case 'inbox':
            this.unTaggedConversationQty = this.menuCount.inboxCustomerCount - this.countTaggedConversation
            break
          case 'reminder':
            this.unTaggedConversationQty = this.menuCount.reminderCustomerCount - this.countTaggedConversation
            break
          case 'active':
            this.unTaggedConversationQty = this.menuCount.activeCustomerCount - this.countTaggedConversation
            break
        }
      }
      this.updateActiveMenuCount()
    },
    updateActiveMenuCount () {
      // Update count of active menu based on selected tags
      if (this.menuType !== 'active' || this.customerType !== 'customer') {
        return
      }

      const fallbackActiveCount = this.menuCount && typeof this.menuCount.activeCustomerCount === 'number'
        ? this.menuCount.activeCustomerCount
        : null

      // แก้ไขหากไม่มี Tag ใดๆถูกเลือกก็จะใช้ fallbackActiveCount (จำนวนเดิมไปก่อน)
      if (!Array.isArray(this.selectedTagIds) || this.selectedTagIds.length === 0) {
        if (fallbackActiveCount !== null) {
          this.$emit('onUpdateActiveMenu', fallbackActiveCount)
        }
        return
      }

      const allTags = this.getAllTags()
      let sumCount = 0
      let hasResolvedSelectedCount = false

      if (this.selectedTagIds.includes(0) && typeof this.unTaggedConversationQty === 'number') {
        sumCount += this.unTaggedConversationQty
        hasResolvedSelectedCount = true
      }

      for (const tag of allTags) {
        if (this.selectedTagIds.includes(tag.id) && typeof tag.tag_count === 'number') {
          sumCount += tag.tag_count
          hasResolvedSelectedCount = true
        }
      }

      if (!hasResolvedSelectedCount && fallbackActiveCount !== null) {
        this.$emit('onUpdateActiveMenu', fallbackActiveCount)
        return
      }

      this.$emit('onUpdateActiveMenu', sumCount)
    },
    selectAll () {
      this.admin = null
      this.adminId = null
      this.$refs.selectedItems.deactivate()
      this.searchConversation()
      if (this.searchConversationParams.menu === 'active') {
        this.$store.commit('conversation/SET_SELECTED_ADMIN', null)
      }
    },
    searchProfessional: _.debounce(async (loading, search, vm) => {
      let url = `beneat/professionals?keywords=${escape(search)}`
      try {
        let { data } = await axios.get(url)
        vm.professionals = data.professionals
      } catch (e) {
        alert('ค้นหาผิดพลาด: ' + e.message)
      }
      loading(false)
    }, 350),
    professionalChanged (professional) {
      this.searchConversation()
    },
    onSearchProfessional (search, loading) {
      loading(true)
      if (!escape(search).trim()) {
        loading(false)
      }
      this.searchProfessional(loading, search, this)
    },
    onChangeAdmin (admin) {
      this.adminId = (admin) ? admin.id : null
      this.searchConversation()
      if (this.searchConversationParams.menu === 'active') {
        this.$store.commit('conversation/SET_SELECTED_ADMIN', admin)
      }
      this.fetchParentChatTopics()
    },
    async onChange (tags) {
      // console.log('onChange tags', tags)
      // return
      // Handle null value received when the button 'Clear หัวข้อ' is pressed
      if (!tags) {
        this.selectedTags = null
        this.selectedTagIds = []
        this.searchConversation()
        return
      }

      // ถ้าเป็นการส่งมาเป็น object ให้ convert เป็น array
      if (typeof tags === 'object' && !Array.isArray(tags) && tags !== null) {
        tags = [tags]
      }

      if (!Array.isArray(this.selectedTags)) {
        this.selectedTags = []
      }

      let tagIds = []
      // tags.forEach(tag => {
      //   const index = this.selectedTags.findIndex(item => item.id === tag.id)
      //   if (index !== -1) {
      //     this.selectedTags.splice(index, 1)
      //   } else {
      //     this.selectedTags.push(tag)
      //   }
      // })

      tagIds = tags.map(tag => tag.id)

      // this.selectedTagIds = this.selectedTags.map(tag => tag.id)
      this.selectedTags = tags
      this.selectedTagIds = tagIds
      await nextTick()
      this.searchConversation()
      this.updateActiveMenuCount()
    },
    clearSearch (clearOnlyRadio = false) {
      if (!clearOnlyRadio) {
        this.keyword = null
        this.admin = null
        this.adminId = null
        this.selectedTags = null
        this.selectedChatTopic = null
        this.selectedProvinceId = null
        this.selectedProfessional = null
        this.conversationCreatedDate = null
      }
      this.isNotResponse = null
      this.unread = null
      this.isReminder = 0
    },
    searchConversation () {
      const searchData = {
        page: 0,
        keyword: this.keyword ? this.keyword.trim() : null,
        tag_id: null,
        filter_by_and_or: this.filterByAndOr,
        admin_id: this.adminId,
        unread: this.unread,
        is_not_response: this.isNotResponse,
        is_reminder: this.isReminder,
        is_emergency: this.isEmergency,
        province_id: this.selectedProvinceId,
        professional_id: this.selectedProfessional ? this.selectedProfessional.id : null,
        conversation_created_date: this.conversationCreatedDate ? moment(this.conversationCreatedDate).format('YYYY-MM-DD') : null,
        from_search: true,
        professional_group: this.professionalGroup
      }
      if (this.selectedTagIds && this.selectedTagIds.length > 0) {
        searchData.tag_id = this.selectedTagIds
      }
      this.$emit('onSearch', searchData)
    },
    searchConversationByChatTopicIds (parentChatTopic) {
      this.selectedChatTopic = parentChatTopic
      const childChatTopicIds = parentChatTopic.child_chat_topic_ids
      if (childChatTopicIds && childChatTopicIds.length > 0) {
        const searchData = {
          page: 0,
          keyword: this.keyword ? this.keyword.trim() : null,
          tag_id: null,
          admin_id: this.adminId,
          unread: this.unread,
          is_not_response: this.isNotResponse,
          is_reminder: this.isReminder,
          province_id: this.selectedProvinceId,
          professional_id: this.selectedProfessional ? this.selectedProfessional.id : null,
          from_search: true,
          beneat_chat_topic_ids: childChatTopicIds
        }
        this.$emit('onSearch', searchData)
      }
    },
    async fetchProvince () {
      try {
        let { data } = await axios.get('/provinces')
        this.provinces = data.provinces
      } catch (err) {
        this.$swal({ text: err.message, type: 'error' })
      }
    }
  },
  async mounted () {
    this.syncConversationCreatedDate()
    await this.fetchAdmins()
    await this.fetchProvince()
    await this.fetchTags({
      include_count: false,
      customer_type: this.customerType,
      system: 0
    })
    await this.fetchSystemTags({
      include_count: true,
      customer_type: 'customer',
      system: 1
    })
    this.$store.commit('conversation/SET_SELECTED_ADMIN', null)
    this.fetchParentChatTopics()
  }
}
</script>

<style scoped>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

.chat-topic-row:hover {
  background-color: #ECEFF1;
  cursor: pointer;
}

.filter-tooltip {
  position: absolute;
  top: -12px;
  right: -7px;
}

.filter-tooltip:hover::after {
  content: attr(data-tooltip);
  position: absolute;
  background-color: #333;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 1000;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 5px;
}

.recruitment-date-filter {
  display: flex;
  align-items: center;
  gap: 6px;
}

.recruitment-date-label {
  color: #4f6475;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.recruitment-date-clear {
  white-space: nowrap;
  flex-shrink: 0;
}

.recruitment-date-input {
  background-color: #fff;
}
</style>
